// ----------------------------------------------------------------------------
// Component: Tab
// ----------------------------------------------------------------------------
//
// TAB component with desktop tab functionality.
//
// Requires the following structure:
// .js-tab__item
//     .js-tab__button
//     .js-tab__content
//
// When the button is clicked, 'isOpen' class is added/removed for all three
// elements.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/icon/icon';

// Styles
import './_tabs.scss';


// Constant elements
const TAB_BUTTON = '.css-grid__item--card';
const TAB_CONTENT = '.css-grid__item--panel';

// Constant trigger classes
const OPEN_CLASS = 'js-active';

// Open first tab on page load
$('.css-grid--accordion').each(function(index) {
    $(this).children(TAB_BUTTON).first().addClass('js-active');
    $(this).children(TAB_CONTENT).first().addClass('js-active');
});


function tabOpen(tab) {
    const $panel = tab.next(TAB_CONTENT);
    const hash   = '#' + $panel.attr('id');

    // Close all other Panels
    tab.siblings().removeClass('js-active');

    // Toggle the Current Panel
    if (tab.hasClass('js-active')) {
        if($(window).width() < 1025) {
            tab.removeClass('js-active');
            $panel.removeClass('js-active');
        }else{
            tab.addClass('js-active');
            $panel.addClass('js-active');
        }
    } else {
        tab.addClass('js-active');
        $panel.addClass('js-active');

        // Add the hash  to the URL
        if (history.pushState) {
            history.pushState(null, null, hash);
        } else {
            location.hash = hash;
        }

        if($(window).width() < 1025) {
            // // Scroll to the Panel portion when opening
            $('html, body').animate({
                scrollTop: $panel.offset().top - 180
            }, 500);
        }
    }
}

// Card opens Panel
$(TAB_BUTTON).on('click', function(event) {
    tabOpen($(this));
});

// Accessibility keypress opens Panel
$(TAB_BUTTON).keypress(function(event) {
    if (event.which == 13) {
        tabOpen($(this));
    }
});
